document.addEventListener('DOMContentLoaded', () => {

  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  function initSpotlightProducts() {

    const sliders = document.querySelectorAll('.product-images-slider.embla');

    sliders.forEach(root => {

      const viewport = root.querySelector('.embla__viewport');
      const slides = Array.from(root.querySelectorAll('.embla__slide'));
      const prevBtn = root.querySelector('.embla__prev');
      const nextBtn = root.querySelector('.embla__next');
      const dotsWrap = root.querySelector('.embla__dots');

      const embla = EmblaCarousel(viewport, { 
        loop: false, 
        draggable: false, 
        align: 'center', 
        containScroll: false,
        startIndex: slides.length > 1 ? 1 : 0
      });

      dotsWrap.innerHTML = '';
      const dots = slides.map((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'embla__dot';
        dot.type = 'button';
        dot.addEventListener('click', () => embla.scrollTo(i));
        dotsWrap.appendChild(dot);
        return dot;
      });

      function update() {
        const index = embla.selectedScrollSnap();
        slides.forEach((slide, i) => slide.classList.toggle('is-selected', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('is-selected', i === index));
        if (prevBtn) prevBtn.style.display = embla.canScrollPrev() ? 'block' : 'none';
        if (nextBtn) nextBtn.style.display = embla.canScrollNext() ? 'block' : 'none';
      }

      embla.on('select', update);

      function initFade() {
        embla.reInit(); // recalc sizes
        // embla.scrollTo(initialIndex, true);
        update();

        root.classList.remove('is-loading');
      }

      const images = slides.map(slide => slide.querySelector('img'));
      let loadedCount = 0;

      function handleImageLoaded() {
        loadedCount++;
        // trigger fade once first image is ready
        // if (loadedCount === 1) {
          initFade();
        // }
      }

      // loop through all images
      images.forEach(img => {
        if (img && !img.complete) {
          img.addEventListener('load', handleImageLoaded, { once: true });
          img.addEventListener('error', handleImageLoaded, { once: true });
        } else {
          handleImageLoaded();
        }
      });

      if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
      if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());
    });

    // console.log('initSpotlightProducts')
  }
  initSpotlightProducts();
  
  function updateSpotlightProducts() {
    
    const variantEvent = isTouch ? 'click' : 'mouseenter';

    document.querySelectorAll('.variant-spotlight').forEach(link => {
      if (link.dataset.bound === "1") return;
      link.dataset.bound = "1";

      // preload (optional)
      const preloadImages = JSON.parse(link.dataset.productVariantImages || '[]');
      const lazyPreload = () => {
        if (!preloadImages.length) return;
        preloadImages.forEach(src => {
          const img = new Image();
          img.loading = 'eager';
          img.src = src;
        });
      };
      setTimeout(() => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(lazyPreload, { timeout: 2000 });
        } else {
          setTimeout(lazyPreload, 1000);
        }
      }, 4000);

      link.addEventListener(variantEvent, (e) => {
        if (isTouch) e.preventDefault();
        if (link.classList.contains('active')) return;

        const images = JSON.parse(link.dataset.productVariantImages || '[]');
        const productCard = link.closest('.product-tile__container');
        if (!productCard) return;

        const slidesContainer = productCard.querySelector('.embla__container');
        const viewport       = productCard.querySelector('.embla__viewport');
        const prevBtn        = productCard.querySelector('.embla__prev');
        const nextBtn        = productCard.querySelector('.embla__next');
        const dotsWrap       = productCard.querySelector('.embla__dots');

        // update price
        const priceEl = productCard.querySelector(".product-tile__meta .product-tile-meta__price");
        if (priceEl && link.dataset.productVariantPrice) {
          priceEl.innerHTML = link.dataset.productVariantPrice;
        }

        // update title link
        const titleLink = productCard.querySelector("a.product-tile-meta__title");
        if (titleLink) titleLink.href = link.href;
        
        slidesContainer.href = link.href;

        // update short description
        if (link.dataset.productVariantDescription) {
          const descEl = productCard.querySelector('.product-tile-short-description');
          if (descEl) {
            const cleanDesc = link.dataset.productVariantDescription
              .replace(/^<p[^>]*>/i, '')
              .replace(/<\/p>$/i, '');
            descEl.innerHTML = `<p>${cleanDesc}</p>`;
          }
        }

        // replace slides
        if (slidesContainer) {
          slidesContainer.innerHTML = images.map(url => `
            <div class="embla__slide">
              <img src="${url}" alt="">
            </div>
          `).join('');
        }

        // destroy previous embla for THIS card
        const oldEmbla = productCard._embla;
        if (oldEmbla) oldEmbla.destroy();

        const isMobile = window.matchMedia('(max-width: 1024px)').matches;
        const options = isMobile
          ? { loop: false, draggable: true,  align: 'start',  startIndex: 1 }
          : { loop: false, draggable: false, align: 'center', containScroll: false, startIndex: 1 };

        // slidesContainer.offsetHeight;
        const embla = EmblaCarousel(viewport, options);
        productCard._embla = embla; // store for next time
        
        // dots
        let dots = [];
        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          const slideEls = slidesContainer.querySelectorAll('.embla__slide');
          dots = Array.from(slideEls).map((_, i) => {
            const dot = document.createElement('button');
            dot.className = 'embla__dot';
            dot.type = 'button';
            dot.addEventListener('click', () => embla.scrollTo(i));
            dotsWrap.appendChild(dot);
            return dot;
          });
        }

        // update UI on select
        const slideEls = slidesContainer.querySelectorAll('.embla__slide');
        const update = () => {
          const index = embla.selectedScrollSnap();
          slideEls.forEach((slide, i) => slide.classList.toggle('is-selected', i === index));
          dots.forEach((dot, i) => dot.classList.toggle('is-selected', i === index));
          if (prevBtn) prevBtn.style.display = embla.canScrollPrev() ? 'block' : 'none';
          if (nextBtn) nextBtn.style.display = embla.canScrollNext() ? 'block' : 'none';
        };
        embla.on('select', update);
        embla.on('init', update);
        embla.on('reInit', update);

        // bind prev/next ONCE per card
        if (!productCard.dataset.navBound) {
          if (prevBtn) prevBtn.addEventListener('click', () => {
            const inst = productCard._embla;
            if (inst) inst.scrollPrev();
          });
          if (nextBtn) nextBtn.addEventListener('click', () => {
            const inst = productCard._embla;
            if (inst) inst.scrollNext();
          });
          productCard.dataset.navBound = "1";
        }

        function goToSecondSlide(embla) {

          const slides = embla.slideNodes();
          const hasSecond = slides.length > 1;
          
          if (hasSecond) {  
            setTimeout(() => {

              // embla.scrollTo(1, true);
              // slides.forEach((slide, i) => {
              //   slide.classList.toggle('is-selected', i === 1);
              // });

              const imgs = slidesContainer.querySelectorAll('img');
              Promise.all(
                Array.from(imgs).map(img =>
                  img.complete && img.naturalWidth > 0
                    ? Promise.resolve()
                    : new Promise(res => {
                        img.addEventListener('load', res, { once: true });
                        img.addEventListener('error', res, { once: true });
                      })
                )
              ).then(() => {
                embla.reInit();
                embla.scrollTo(1, true);
              });
            }, 0);
          }
        }
        
        // --- ensure second slide is active after init ---
        embla.on('init', (api) => {
          requestAnimationFrame(() => {
            goToSecondSlide(api);
          });
        });
        
        // Also ensure dots and UI reflect the same state
        // embla.on('init', () => {
        //   const dots = dotsWrap?.querySelectorAll('.embla__dot') || [];
        //   dots.forEach((dot, i) => dot.classList.toggle('is-selected', i === 1));
        // });

        // active state for variants
        productCard.querySelectorAll('.variant-spotlight.active').forEach(sib => sib.classList.remove('active'));
        link.classList.add('active');
      });
    });
  }


  // function updateSpotlightProducts() {

  //   // Thumbs handler
  //   const variantEvent = isTouch ? 'click' : 'mouseenter';

  //   document.querySelectorAll('.variant-spotlight').forEach(link => {
  //     if (link.dataset.bound === "1") return;
  //     link.dataset.bound = "1";

  //     // Lazy preloading of variant images
  //     const preloadImages = JSON.parse(link.dataset.productVariantImages || '[]');
  //     const lazyPreload = () => {
  //       if (!preloadImages.length) return;
  //       // console.groupCollapsed(`Preloading spotlight variant for ${link.dataset.productVariantId || '(unknown)'}`);
  //       preloadImages.forEach(src => {
  //         const img = new Image();
  //         img.loading = 'eager';
  //         img.src = src;
  //         // img.onload = () => console.log('Cached', src);
  //         // img.onerror = () => console.warn('Failed to preload', src);
  //         // console.log('Preloading', src);
  //       });
  //       console.groupEnd();
  //     };

  //     // Delayed lazyPreload start
  //     setTimeout(() => {
  //       if ('requestIdleCallback' in window) {
  //         // console.log(`Queued preload for ${link.dataset.productVariantId || '(unknown)'} (will run when browser idle)`);
  //         requestIdleCallback(lazyPreload, { timeout: 2000 });
  //       } else {
  //         // console.log(`Fallback preload scheduled for ${link.dataset.productVariantId || '(unknown)'} (after 1s timeout)`);
  //         setTimeout(lazyPreload, 1000);
  //       }
  //     }, 4000);

  //     link.removeEventListener(variantEvent, function(e){});
  //     link.addEventListener(variantEvent, (e) => {

  //       if( isTouch ) {
  //         e.preventDefault();
  //       }

  //       if (link.classList.contains('active')) return;
        
  //       const images = JSON.parse(link.dataset.productVariantImages || '[]');
  //       const price  = link.dataset.price || '';

  //       const productCard = link.closest('.product-tile__container');
  //       const slidesContainer = productCard.querySelector('.embla__container');
  //       const priceEl = productCard.querySelector(".product-tile__meta .product-tile-meta__price");
  //       const prevBtn = productCard.querySelector('.embla__prev');
  //       const nextBtn = productCard.querySelector('.embla__next');
  //       const dotsWrap = productCard.querySelector('.embla__dots');
  //       let embla;

  //       // update price
  //       if (priceEl && link.dataset.productVariantPrice) {
  //         priceEl.innerHTML = link.dataset.productVariantPrice;
  //       }

  //       // update link
  //       const titleLink = productCard.querySelector("a.product-tile-meta__title");
  //       if (titleLink) titleLink.href = link.href;
        
  //       slidesContainer.href = link.href;

  //       // Replace slides with new images
  //       slidesContainer.innerHTML = images.map(url => `
  //         <div class="embla__slide">
  //           <img src="${url}" alt="">
  //         </div>
  //       `).join('');
        
  //       const isMobile = window.matchMedia('(max-width: 1024px)').matches;
  //       const viewport = productCard.querySelector('.embla__viewport');

  //       if (embla) embla.destroy();
        
  //       const options = isMobile ? {
  //           loop: false, 
  //           draggable: true,
  //           align: 'start',
  //           startIndex: 1
  //         }
  //       :
  //       { 
  //         loop: false, 
  //         draggable: false, 
  //         align: 'center', 
  //         containScroll: false,
  //         startIndex: 1
  //       };

  //       embla = EmblaCarousel(viewport, options);
        
  //       embla.on('init', async (emblaApi) => {
          
  //         const viewport = emblaApi.rootNode();
  //         const root = viewport.closest('.product-images-slider.embla') || viewport;
  //         const slides = emblaApi.slideNodes();
          
  //         embla.scrollTo(1, true); // init slide
  //         // slides.forEach((slide, i) => slide.classList.toggle('is-selected', i === 1));
          
  //         console.log('init 1')
  //       });

  //       dotsWrap.innerHTML = '';
  //       const slides = slidesContainer.querySelectorAll('.embla__slide');
  //       const dots = Array.from(slides).map((_, i) => {
  //         const dot = document.createElement('button');
  //         dot.className = 'embla__dot';
  //         dot.type = 'button';
  //         dot.addEventListener('click', () => embla.scrollTo(i));
  //         dotsWrap.appendChild(dot);
  //         return dot;
  //       });
        
  //       function update() {
  //         const index = embla.selectedScrollSnap();
  //         slides.forEach((slide, i) => slide.classList.toggle('is-selected', i === index));
  //         dots.forEach((dot, i)   => dot.classList.toggle('is-selected', i === index));
  //         if (prevBtn) prevBtn.style.display = embla.canScrollPrev() ? 'block' : 'none';
  //         if (nextBtn) nextBtn.style.display = embla.canScrollNext() ? 'block' : 'none';

  //         console.log('update 1', index)
  //       }
  //       embla.on('select', update);
        
  //       if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
  //       if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());
        
        
  //       productCard.querySelectorAll('.variant-spotlight.active').forEach(sib => sib.classList.remove('active'));
  //       link.classList.add('active');

  //     });
  //   });
  // }

  // View More label (+5)
  const LIMIT = 4;
  const MOBILE_MAX_WIDTH = 1025;

  function applyViewMoreBehavior() {

    if (window.innerWidth < MOBILE_MAX_WIDTH) return;

    document.querySelectorAll('.variant-thumbnails').forEach(container => {
      // Collect both types of variants
      const items = Array.from(container.querySelectorAll('a.variant-spotlight'));
      if (items.length <= LIMIT) return; // nothing to hide

      // Remove any existing "+N" label
      container.querySelector('.variant-more')?.remove();

      // Hide items beyond LIMIT
      items.forEach((item, i) => {
        if (i >= LIMIT) item.style.display = 'none';
      });

      // Create "+N" label
      const hiddenCount = items.length - LIMIT;
      const moreLabel = document.createElement('div');
      moreLabel.className = 'variant-more';
      moreLabel.textContent = `+${hiddenCount}`;
      container.appendChild(moreLabel);

      // Click → instantly reveal all hidden items
      const moreLabelEvent = isTouch ? 'touchstart' : 'mouseenter';
      moreLabel.addEventListener(moreLabelEvent, () => {
        items.forEach(item => (item.style.display = 'inline-block'));
        moreLabel.remove();
      });
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      updateSpotlightProducts();
      applyViewMoreBehavior();
    }, 200); // runs once, 200ms after user stops resizing
  });

  const spotlightorigFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    if (typeof url === "string" && url.includes("/collections/")) {
      // console.log("Fetching collection products:", url);
    }
    return spotlightorigFetch.apply(this, arguments).then(res => {
      if (res.url.includes("/collections/")) {
        // console.log("Collection products fetched:", res.url);
        setTimeout(()=>{
          updateSpotlightProducts();
          applyViewMoreBehavior();
        }, 100)
      }
      return res;
    });
  };

});
